/* External dependencies */
import React from 'react';

/* Local dependencies */
import { IconProps } from './types';

export default function ArrowPointingToTheRightIcon({
  height,
  width,
}: IconProps) {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 24 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M15 5.5L13.59 6.91L18.17 11.5H2V13.5H18.17L13.58 18.09L15 19.5L22 12.5L15 5.5Z"
        fill="#8F9BB3"
      />
    </svg>
  );
}
